import { gql, useMutation } from '@apollo/client'

interface Result {
  undoStoreOrder: boolean
}

interface Form {
  id: string
}

const mutation = gql`
  mutation UndoStoreOrder($id: ID!) {
    undoStoreOrder(id: $id)
  }
`

const useUndoStoreOrder = () => {
  const [mutate] = useMutation<Result, Form>(mutation)
  return (variables: Form) => mutate({ variables })
}

export default useUndoStoreOrder
